import React from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import './index.css';
import { toast } from 'react-toastify';
import spinner from '../assign-prescriptions/images/spinner.gif';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Selector from '../select';
import AddUserImage from '@mui/icons-material/CloudUpload';
import DateAdapter from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
import DesktopTimePicker from '@mui/lab/DesktopTimePicker';
import {
  Grid,
  InputLabel,
  MenuItem,
  FormControl,
  Icon,
  IconButton,
  Tooltip,
  TextField,
} from '@mui/material';
import {
  TextValidator,
  ValidatorForm,
  SelectValidator,
} from 'react-material-ui-form-validator';
import Dropzone from 'react-dropzone';
import EventIcon from '@mui/icons-material/Event';
import socketIOClient from 'socket.io-client';
import { Typography } from '@mui/material';
import { withStyles } from '@mui/styles';
import { withTranslation } from 'react-i18next';
import enLocale from 'date-fns/locale/en-US';
import frLocale from 'date-fns/locale/fr';
const localizer = momentLocalizer(moment);

const useStyles = (theme) => ({
  button: {
    display: 'block',
    marginTop: '2px',
  },
  formControl: {
    margin: '5px',
    minWidth: '100%',
  },
  formControlPatientComment: {
    minWidth: '100%',
  },
  gridSelect: {
    marginTop: '8px',
  },
  grid: {
    marginLeft: '5px',
  },
  buttonAllignment: {
    float: 'right',
  },
  formDescription: {
    margin: '5px',
    minWidth: '100%',
    border: '1px solid black',
  },
  flexItems: {
    display: 'flex',
    marginTop: '10px',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  picturedropbox: {
    width: '200px',
    height: '150px',
    textAlign: 'center',
    boxShadow:
      '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
    overflow: 'hidden',
    top: '10px',
    position: 'relative',
    marginBottom: '15px',
  },
  dropImage: {
    width: '80%',
    height: '100%',
  },
  dropPic: {
    width: '100%',
    height: '100%',
  },
  innerBox: {
    margin: '0 auto',
    display: 'block',
    height: '100%',
  },
  captionpictureText: {
    lineHeight: '1',
    color: '#8a8a8a',
    fontSize: '13px',
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none',
  },
  btnremove: {
    fontSize: '0.675rem',
  },
  editAppointment: {
    transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:hover': {
      backgroundColor: '#6cca98',
      color: '#fff',
    },
  },
  deleteAppointment: {
    transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:hover': {
      backgroundColor: '#6cca98',
      color: '#fff',
    },
  },
  primaryButton: {
    background: '#6cca98',
    color: '#fff',
    '&:hover': {
      background: '#6cca98',
      color: '#fff',
    },
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.38)',
      cursor: 'not-allowed',
      background: '#E4E5E8',
    },
  },
});

const propTypes = {};

// let allViews = Object.keys(Views).map((k) => Views[k]);

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      openDialog: false,
      operation: 'Add',
      isOpenAppointmentTypeSelect: false,
      appointmentType_ID: null,
      appointmentTypeMaster: [],
      addPatientValues: [],
      patient_ID: null,
      parent_account_ID: null,
      isOpenDeleteDialog: false,
      isButtonDisabled: false,
      appointmentDetatil: [],
      duration: '',
      locationObj: [],
      appointment: {},
      LoggedInUserName: '',
      userData: [],
      selectedRowID: null,
      isOpenLocationSelect: false,
      location_ID: null,
      innerLoader: false,
      deleteinnerLoader: false,
      picture1_URL: '',
      picture2_URL: '',
      picture3_URL: '',
      title: '',
      add_patient: '',
      location: '',
      patient_comments: '',
      description: '',
      start_date: new Date(),
      end_date: new Date(),
      time: new Date(),
      events: [],
      socket: null,
      AppointmentErrorMessage: null,
      AppointmentTypeErrorMessage: null,
      PatientErrorMessage: null,
      AppointmentLocationErrorMessage: null,
      AppointmentTypeByIdErrorMessage: null,
      AppointmentCreateErrorMessage: null,
      AppointmentUpdateErrorMessage: null,
      AppointmentDeleteErrorMessage: null,
      locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale,
      //client: null
    };
  }

  componentWillMount = async () => {
    await this.initSocketIO();
    this.getAppointmentTypeMaster();
    this.getPatientDetails();
    this.getAppointmentLocationMaster();
    this.getLoginedUserName();
  };

  componentWillUnmount = () => {};

  initSocketIO = async () => {
    const user = sessionStorage.getItem('user');
    if (!this.socket && user) {
      this.socket = socketIOClient(process.env.REACT_APP_VIDEO_SOCKET_BASEURL, {
        transports: ['websocket'],
        auth: {
          token: `Bearer ${
            JSON.parse(user).signInUserSession.idToken.jwtToken
          }`,
        },
        secure: true,
      });

      this.socket &&
        this.socket.on('connect', () => {
          console.log(
            'Socket.io connection established to getting Appointment'
          );
        });
      this.socket &&
        this.socket.on('connect_error', (error) => {
          console.log('Connect Error: ', error);
        });
      this.socket &&
        this.socket.on('connect_failed', (error) => {
          console.log('Connect Failed: ', error);
        });
      this.socket &&
        this.socket.on('error', (error) => {
          console.log('Error: ', error);
        });
      this.socket &&
        this.socket.on('disconnect', (reason) => {
          console.log(
            `Socket Disconnected From Portal and Reason is: ${reason}`
          );
        });
      //this.setState({ socket });
      await this.emitSocketToSendingEvents();
    }
  };

  emitSocketToSendingEvents = async () => {
    this.socket &&
      this.socket.emit('ReadAppointment', { AuthorizeType: 'Appointment' });
    console.log('Socket.io emitting events to server:');
    await this.emitSocketToRecevingEvents();
  };

  emitSocketToRecevingEvents = async () => {
    this.socket &&
      this.socket.on('ReadStatusAppointment', async (response) => {
        console.log('Socket.io reciving server events:', response);
        if (
          response &&
          response.Message &&
          response.Message.AuthorizeType === 'Appointment'
        ) {
          await this.gettingAppointmentEventsDetails();
        }
      });
    this.socket &&
      this.socket.on('WrongAppointmentTypePassing', async (response) => {
        console.log('Socket.IO reciving server events:', response);
        this.setState({
          wrongType: response && response.Message.AuthorizeType,
        });
      });
  };

  emitSocketToDeleteAppointment = () => {
    this.socket &&
      this.socket.emit(
        'DeleteAppointment',
        'Sending request to server for deleting Appointment events!'
      );
    console.log('Socket.io emitting events for delete Appointment Events:');
  };

  emitSocketToUpdateAppointment = () => {
    this.socket &&
      this.socket.emit(
        'UpdateAppointment',
        'Sending request to server for updating Appointment events!'
      );
    console.log('Socket.io emitting events for update Appointment Events:');
  };

  emitSocketToCreateAppointment = () => {
    this.socket &&
      this.socket.emit(
        'CreateAppointment',
        'Sending request to server for creating Appointment events!'
      );
    console.log('Socket.io emitting events for create Appointment Events:');
  };

  gettingAppointmentEventsDetails = async () => {
    try {
      fetch(
        process.env.REACT_APP_BASEURL +
          'appointment/app/GettingAppointmentsDetails',
        {
          method: 'POST',
          withCredentials: true,
          headers: {
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
            'Content-Type': 'application/json',
          },
        }
      )
        .then((response) => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        })
        .then(async (res) => {
          if (
            res &&
            res.results &&
            res.results.length &&
            res.results.length > 0 &&
            res &&
            res.status === 200
          ) {
            this.setState({ appointmentDetatil: res.results });
            const appointmentEvents = res.results.map(function(element) {
              let _startDate = moment(element.appointment_start_date).format(
                'HH:mm a'
              );
              return {
                id: element.id,
                start: new Date(element.appointment_start_date),
                end: new Date(element.appointment_end_date),
                title: `(${_startDate}) ${element.title}`,
              };
            });
            this.setState({ events: appointmentEvents });
          } else if (res.status === 400 || res.status === 404) {
            this.setState({ events: [], AppointmentErrorMessage: res.message });
            console.log(this.state.AppointmentErrorMessage);
          } else if (res.status === 500) {
            this.setState({ events: [], AppointmentErrorMessage: res.error });
            console.log(this.state.AppointmentErrorMessage);
          }
        });
    } catch (error) {
      console.log(
        'Something Went wrong to getting Events! please try again',
        error
      );
    }
  };

  getAppointmentTypeMaster = () => {
    try {
      fetch(process.env.REACT_APP_BASEURL + 'appointment/app/AppointmentType', {
        method: 'get',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          try {
            return response.json();
          } catch (error) {
            return error;
          }
        })
        .then((data) => {
          if (
            data &&
            data.results &&
            data.results.length > 0 &&
            data &&
            data.status === 200
          ) {
            const appointmentTypeMaster = data.results.map((res) => {
              return { id: res.id, type: res.type, duration: res.duration };
            });
            this.setState({ appointmentTypeMaster });
          } else if (data.status === 400 || data.status === 404) {
            this.setState({
              appointmentTypeMaster: [],
              AppointmentTypeErrorMessage: data.message,
            });
            console.log(this.state.AppointmentTypeErrorMessage);
          } else if (data.status === 500) {
            this.setState({
              appointmentTypeMaster: [],
              AppointmentTypeErrorMessage: data.error,
            });
            console.log(this.state.AppointmentTypeErrorMessage);
          }
        });
    } catch (error) {
      console.log(
        'Something Went wrong to getting appointment types! please try again',
        error
      );
    }
  };

  getPatientDetails = () => {
    try {
      fetch(process.env.REACT_APP_BASEURL + 'appointment/app/PatientDetails', {
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          try {
            return response.json();
          } catch (error) {
            return error;
          }
        })
        .then((patientValue) => {
          if (
            patientValue &&
            patientValue.results &&
            patientValue.results.length > 0 &&
            patientValue &&
            patientValue.status === 200
          ) {
            const patientValues = patientValue.results.map((res) => {
              return {
                value: res.id,
                label: res.name,
                account_id: res.parent_account_id,
              };
            });
            this.setState({
              addPatientValues: patientValues,
              patient_ID: patientValues && patientValues[0].value,
              parent_account_ID: patientValues && patientValues[0].account_id,
            });
          } else if (
            patientValue.status === 400 ||
            patientValue.status === 404
          ) {
            this.setState({
              addPatientValues: [],
              PatientErrorMessage: patientValue.message,
            });
            console.log(this.state.PatientErrorMessage);
          } else if (patientValue.status === 500) {
            this.setState({
              addPatientValues: [],
              PatientErrorMessage: patientValue.message,
            });
            console.log(this.state.PatientErrorMessage);
          }
        });
    } catch (error) {
      console.log(
        'Something Went wrong to getting patient details! please try again',
        error
      );
    }
  };

  getAppointmentLocationMaster = () => {
    try {
      fetch(
        process.env.REACT_APP_BASEURL +
          'appointment/app/getAppointmentLocation',
        {
          method: 'GET',
          headers: {
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
            'Content-Type': 'application/json',
          },
        }
      )
        .then((response) => {
          try {
            return response.json();
          } catch (error) {
            return error;
          }
        })
        .then((response) => {
          if (
            response &&
            response.results.length &&
            response.results.length > 0 &&
            response &&
            response.status === 200
          ) {
            const locationObj = response.results.map((ele) => {
              return { id: ele.id, name: ele.name };
            });
            this.setState({ locationObj });
          } else if (response.status === 400 || response.status === 404) {
            this.setState({
              locationObj: [],
              AppointmentLocationErrorMessage: response.message,
            });
            console.log(this.state.AppointmentLocationErrorMessage);
          } else if (response.status === 500) {
            this.setState({
              locationObj: [],
              AppointmentLocationErrorMessage: response.message,
            });
            console.log(this.state.AppointmentLocationErrorMessage);
          }
        });
    } catch (error) {
      console.log(
        'Something Went wrong to getting appointment locations details! please try again',
        error
      );
    }
  };

  getLoginedUserName = () => {
    fetch(
      process.env.REACT_APP_BASEURL +
        'users/' +
        JSON.parse(sessionStorage.getItem('user')).username,
      {
        method: 'GET',
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
      }
    )
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((uData) => {
        if (uData) {
          const userData = JSON.parse(uData);
          this.setState({ LoggedInUserName: userData && userData[0].name });
          this.setState({ userData });
        }
      });
  };

  getApointmentEventsByID = (eventID) => {
    this.setState({ innerLoader: true });
    try {
      fetch(
        process.env.REACT_APP_BASEURL +
          'appointment/app/getAppointments/' +
          eventID,
        {
          method: 'get',
          headers: {
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
            'Content-Type': 'application/json',
          },
        }
      )
        .then((response) => {
          try {
            return response.json();
          } catch (error) {
            return error;
          }
        })
        .then((response) => {
          if (response && response.status === 200) {
            console.log(response);
            this.setState({
              innerLoader: false,
              appointment: response.results,
              selectedRowID: response.results.id,
            });
            this.setState({
              title: response && response.results && response.results.title,
              appointmentType_ID:
                response &&
                response.results &&
                response.results.appointment_type_id,
              duration:
                response &&
                response.results &&
                response.results.appoinmenttype &&
                response.results.appoinmenttype.duration,
              location_ID:
                response &&
                response.results &&
                response.results.appointment_location_master_id,
              start_date:
                response &&
                response.results &&
                response.results.appointment_start_date,
              end_date:
                response &&
                response.results &&
                response.results.appointment_end_date,
              patient_ID:
                response && response.results && response.results.patient_id,
              parent_account_ID:
                response &&
                response.results &&
                response.results.patient &&
                response.results.patient.parent_account_id,
              patient_comments:
                response &&
                response.results &&
                response.results.patient_comments,
              description:
                response && response.results && response.results.description,
              picture1_URL:
                response && response.results && response.results.picture1_url,
              picture2_URL:
                response && response.results && response.results.picture2_url,
              picture3_URL:
                response && response.results && response.results.picture3_url,
            });
          } else if (
            response &&
            response.status === 404 &&
            response &&
            response.status === 400
          ) {
            this.setState({
              innerLoader: false,
              AppointmentTypeByIdErrorMessage: response.message,
              appointment: {},
            });
          } else if (response && response.status === 500) {
            this.setState({
              innerLoader: false,
              AppointmentTypeByIdErrorMessage: response.message,
              appointment: {},
            });
          }
        })
        .catch((error) => {
          this.setState({ innerLoader: false });
        });
    } catch (error) {
      this.setState({ innerLoader: false });
    }
  };

  onSelectEvent = (event) => {
    const eventID = event && event.id;
    if (eventID) {
      this.setState({ openDialog: true, operation: 'View' });
      //this.getApointmentEventsByID(eventID);
      const selectedObject =
        this.state &&
        this.state &&
        this.state.appointmentDetatil.find((ele) => ele.id === eventID);
      this.setState({
        appointment: selectedObject,
        selectedRowID: selectedObject && selectedObject.id,
        title: selectedObject && selectedObject.title,
        appointmentType_ID:
          selectedObject && selectedObject.appointment_type_id,
        duration:
          selectedObject &&
          selectedObject.appoinmenttype &&
          selectedObject.appoinmenttype.duration,
        location_ID:
          selectedObject && selectedObject.appointment_location_master_id,
        start_date: selectedObject && selectedObject.appointment_start_date,
        end_date: selectedObject && selectedObject.appointment_end_date,
        patient_ID: selectedObject && selectedObject.patient_id,
        parent_account_ID:
          selectedObject &&
          selectedObject.patient &&
          selectedObject.patient.parent_account_id,
        patient_comments: selectedObject && selectedObject.patient_comments,
        description: selectedObject && selectedObject.description,
        picture1_URL: selectedObject && selectedObject.picture1_url,
        picture2_URL: selectedObject && selectedObject.picture2_url,
        picture3_URL: selectedObject && selectedObject.picture3_url,
        LoggedInUserName:
          selectedObject && selectedObject.user && selectedObject.user.name,
      });
    }
  };

  confirmDelete = () => {
    if (this.state && this.state.selectedRowID) {
      this.setState({ isOpenDeleteDialog: true });
    } else {
      this.setState({ isOpenDeleteDialog: true });
    }
  };

  handleCloseDeleteDialog = () => {
    if (this.state && this.state.selectedRowID) {
      this.setState({ isOpenDeleteDialog: false });
    } else {
      this.setState({ isOpenDeleteDialog: false });
    }
  };

  handleConfirmDelete = (event) => {
    event.preventDefault();
    if (this.state && this.state.selectedRowID) {
      this.handleDelete(this.state.selectedRowID);
    }
  };

  handleDelete = (eventID) => {
    this.setState({ deleteinnerLoader: true });
    try {
      fetch(
        process.env.REACT_APP_BASEURL +
          'appointment/app/DeleteAppointments/' +
          eventID,
        {
          method: 'delete',
          headers: {
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
            'Content-Type': 'application/json',
          },
        }
      )
        .then((res) => {
          try {
            return res.json();
          } catch (error) {
            return error;
          }
        })
        .then((response) => {
          if (response && response.status === 200) {
            this.setState({
              deleteinnerLoader: false,
              openDialog: false,
              isOpenDeleteDialog: false,
              selectedRowID: null,
            });
            toast.success(response.message);
            this.emitSocketToDeleteAppointment();
            this.socket &&
              this.socket.on('DeleteStatusAppointment', (message) => {
                console.log(message);
                this.gettingAppointmentEventsDetails();
              });
          } else if (
            (response && response.status === 400) ||
            (response && response.status === 500)
          ) {
            this.setState({
              deleteinnerLoader: false,
              openDialog: false,
              isOpenDeleteDialog: false,
              selectedRowID: null,
              AppointmentDeleteErrorMessage: response.message,
            });
            console.log(this.state.AppointmentDeleteErrorMessage);
          }
        })
        .catch((error) => {
          this.setState({
            deleteinnerLoader: false,
            openDialog: false,
            isOpenDeleteDialog: false,
            selectedRowID: null,
          });
        });
    } catch (error) {
      console.log(
        'Something Went wrong to delete appointment events details! please try again',
        error
      );
    }
  };

  pad = (n) => {
    return n < 10 ? '0' + n : n;
  };
  tConvert(time) {
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1); // Remove full string match value
      time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join(''); // return adjusted time or original string
  }
  onSelectSlot = ({ start, end, slot, action }) => {
    this.getLoginedUserName();
    const Time = this.pad(
      start.getHours() + ':' + this.pad(start.getMinutes())
    );
    this.setState({
      openDialog: true,
      operation: 'Add',
      title: '',
      start_date: start,
      end_date: end,
      time: Time === '0:00' ? new Date() : start,
      add_patient: '',
      appointmentType_ID: null,
      location_ID: null,
      location: '',
      patient_comments: '',
      description: '',
    });
  };

  onSelecting = (start, end) => {
    console.log(start);
  };
  onShowMore = (event, date) => {
    console.log(event);
  };
  handleCloseDialog = () => {
    this.setState(
      {
        openDialog: false,
        title: '',
        appointmentType_ID: null,
        location_ID: null,
        location: '',
        patient_comments: '',
        description: '',
        picture1_URL: '',
        picture2_URL: '',
        picture3_URL: '',
        appointment: {},
        selectedRowID: null,
        duration: '',
      },
      () => {
        setTimeout(() => {
          this.setState({ operation: 'Add' });
        }, 300);
      }
    );
  };

  handleDateChange = (date) => {
    this.setState({ start_date: date, end_date: date });
  };
  handleTimeChange = (time) => {
    // let timeFormat = moment(time).format("HH:mm:ss");
    // let newTimeFormat = this.tConvert(timeFormat);
    // let splitDate = (newTimeFormat && newTimeFormat.split(':'));
    // console.log(this.pad(splitDate) +':'+ this.pad(splitDate[1]) +':'+ this.pad(splitDate[2]));
    this.setState({ start_date: time }, () =>
      console.log(this.state.start_date)
    );
    // let timeFormat = new Date(time);
    // let newTimeFormat = this.pad(timeFormat.getHours()) +':'+ this.pad(timeFormat.getMinutes()) +':'+ this.pad(timeFormat.getSeconds());
    // let newTime = this.tConvert(newTimeFormat)
    // this.setState({ time: newTime });
  };
  handleChange = (event) => {
    event.preventDefault();
    const value = event && event.target.name;
    switch (value) {
      case 'title':
        this.setState({ title: event.target.value });
        break;

      case 'comment':
        this.setState({ patient_comments: event.target.value });
        break;

      case 'patient':
        this.setState({ add_patient: event.target.value });
        break;

      case 'location':
        this.setState({ location_ID: event.target.value });
        break;

      case 'description':
        this.setState({ description: event.target.value });
        break;

      case 'appointmentType':
        this.setState({ appointmentType_ID: event.target.value }, () => {
          const _data =
            this.state &&
            this.state.appointmentTypeMaster.find((ele) => {
              if (event.target.value === ele.id) {
                return ele;
              }
              return _data;
            });
          this.setState({ duration: _data && _data.duration });
        });
        break;

      default:
        return null;
    }
  };

  handleCloseAppointmentSelect = () => {
    this.setState({ isOpenAppointmentTypeSelect: false });
  };
  hanldeOpenAppointmentSelect = () => {
    this.setState({ isOpenAppointmentTypeSelect: true });
  };
  handleCloseLocationSelect = () => {
    this.setState({ isOpenLocationSelect: false });
  };
  handleOpenLocationSelect = () => {
    this.setState({ isOpenLocationSelect: true });
  };

  handleDropPicture1_URL = (acceptedFiles, rejectedFiles) => {
    this.setState({
      picture1_URL: acceptedFiles[0].preview,
      file: acceptedFiles,
    });
  };
  handleDropPicture2_URL = (acceptedFiles, rejectedFiles) => {
    this.setState({
      picture2_URL: acceptedFiles[0].preview,
      file: acceptedFiles,
    });
  };
  handleDropPicture3_URL = (acceptedFiles, rejectedFiles) => {
    this.setState({
      picture3_URL: acceptedFiles[0].preview,
      file: acceptedFiles,
    });
  };
  removePicture1_URL = () => {
    // const parent = document.getElementById("picture1_DropZone");
    // let imgSrc = (parent.children && parent.children[0]).src = '';
    // let imgFile = new File([imgSrc], "removePicture1_URL");
    this.setState({
      picture1_URL: null,
    });
  };
  removePicture2_URL = () => {
    // const parent = document.getElementById("picture2_DropZone");
    // let imgSrc = (parent.children && parent.children[0]).src = '';
    // let imgFile = new File([imgSrc], "removePicture2_URL");
    this.setState({
      picture2_URL: null,
    });
  };
  removePicture3_URL = () => {
    // const parent = document.getElementById("picture3_DropZone");
    // let imgSrc = (parent.children && parent.children[0]).src = '';
    // let imgFile = new File([imgSrc], "removePicture3_URL");
    this.setState({
      picture3_URL: null,
    });
  };

  getEndDate = (_date, _duration) => {
    return new Date((_date && _date.getTime()) + _duration * 60000);
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({ innerLoader: true });
    this.setState({ isButtonDisabled: true });
    const created_BY = JSON.parse(sessionStorage.getItem('user')).username;
    const Time = new Date(this.state && this.state.start_date);
    const convertTime =
      this.pad(Time.getHours()) + ':' + this.pad(Time.getMinutes());
    let duration = this.state.duration.split('m')[0];
    const _end_Date = this.getEndDate(
      new Date(this.state.start_date),
      duration
    );
    const appointmentObj = {
      title: this.state && this.state.title,
      appointmentStartDate: this.state && this.state.start_date,
      appointmentEndDate: _end_Date,
      appointmentTime: convertTime,
      appointmentType_ID: this.state && this.state.appointmentType_ID,
      location_id: this.state && this.state.location_ID,
      patientID: this.state && this.state.patient_ID,
      accoountID: this.state && this.state.parent_account_ID,
      location: this.state && this.state.location,
      patientComments: this.state && this.state.patient_comments,
      description: this.state && this.state.description,
      created_by: created_BY,
    };
    try {
      fetch(
        process.env.REACT_APP_BASEURL + 'appointment/app/CreateAppointments',
        {
          method: 'post',
          withCredentials: true,
          headers: {
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(appointmentObj),
        }
      )
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return error;
          }
        })
        .then((res) => {
          let appointmentAvailibility = JSON.parse(res);
          if (
            appointmentAvailibility &&
            appointmentAvailibility.status === 200
          ) {
            this.setState({
              innerLoader: false,
              isButtonDisabled: false,
              openDialog: false,
              operation: 'Add',
              title: '',
              start_date: new Date(),
              end_date: new Date(),
              time: new Date(),
              add_patient: '',
              appointmentType_ID: null,
              location_ID: null,
              location: '',
              patient_comments: '',
              description: '',
              duration: '',
            });
            toast.success(this.props.t('Toast.Success.AppointmentCreated'));
            this.emitSocketToCreateAppointment();
            this.socket &&
              this.socket.on('CreateStatusAppointment', (message) => {
                console.log(message);
                this.gettingAppointmentEventsDetails();
              });
          } else if (
            appointmentAvailibility &&
            appointmentAvailibility.status === 500
          ) {
            this.setState({
              innerLoader: false,
              isButtonDisabled: false,
              openDialog: false,
              operation: 'Add',
              title: '',
              start_date: new Date(),
              end_date: new Date(),
              time: new Date(),
              add_patient: '',
              appointmentType_ID: null,
              location_ID: null,
              location: '',
              patient_comments: '',
              description: '',
              duration: '',
              AppointmentCreateErrorMessage: appointmentAvailibility.message,
            });
            console.log(this.state.AppointmentCreateErrorMessage);
          }
        })
        .catch((error) => {
          this.setState({
            isButtonDisabled: false,
            innerLoader: false,
            openDialog: false,
          });
        });
    } catch (error) {
      console.log(
        'Something Went wrong to create appointment events details! please try again',
        error
      );
    }
  };

  handleUpdate = (event) => {
    event.preventDefault();
    this.setState({ isButtonDisabled: true });
    this.setState({ innerLoader: true });
    const MODIFIED_BY = JSON.parse(sessionStorage.getItem('user')).username;
    const Time = new Date(this.state && this.state.start_date);
    const convertTime =
      this.pad(Time.getHours()) + ':' + this.pad(Time.getMinutes());
    const duration = this.state.duration.split('m')[0];
    const _end_Date = this.getEndDate(
      new Date(this.state.start_date),
      duration
    );
    const appointmentObj = {
      id: this.state && this.state.appointment && this.state.appointment.id,
      title: this.state && this.state.title,
      appointmentStartDate: this.state && this.state.start_date,
      appointmentEndDate: _end_Date,
      appointmentTime: convertTime,
      appointmentType_ID: this.state && this.state.appointmentType_ID,
      location_id: this.state && this.state.location_ID,
      patientID: this.state && this.state.patient_ID,
      accoountID: this.state && this.state.parent_account_ID,
      location: this.state && this.state.location,
      patientComments: this.state && this.state.patient_comments,
      description: this.state && this.state.description,
      modified_by: MODIFIED_BY,
    };
    try {
      fetch(
        process.env.REACT_APP_BASEURL + 'appointment/app/UpdateAppointments',
        {
          method: 'PUT',
          withCredentials: true,
          headers: {
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(appointmentObj),
        }
      )
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return error;
          }
        })
        .then((res) => {
          let appointmentAvailibility = JSON.parse(res);
          if (
            appointmentAvailibility &&
            appointmentAvailibility.status === 200
          ) {
            this.setState({
              innerLoader: false,
              isButtonDisabled: false,
              openDialog: false,
              operation: 'Add',
              title: '',
              start_date: new Date(),
              end_date: new Date(),
              time: new Date(),
              add_patient: '',
              appointmentType_ID: null,
              location_ID: null,
              location: '',
              patient_comments: '',
              description: '',
              duration: '',
              appointment: {},
              selectedRowID: null,
            });
            toast.success(this.props.t('Toast.Success.AppointmentUpdated'));
            this.emitSocketToUpdateAppointment();
            this.socket &&
              this.socket.on('UpdateStatusAppointment', (message) => {
                console.log(message);
                this.gettingAppointmentEventsDetails();
              });
          } else if (
            appointmentAvailibility &&
            appointmentAvailibility.status === 500
          ) {
            this.setState({
              innerLoader: false,
              isButtonDisabled: false,
              openDialog: false,
              operation: 'Add',
              title: '',
              start_date: new Date(),
              end_date: new Date(),
              time: new Date(),
              add_patient: '',
              appointmentType_ID: null,
              location_ID: null,
              location: '',
              patient_comments: '',
              description: '',
              duration: '',
              appointment: {},
              selectedRowID: null,
              AppointmentUpdateErrorMessage: appointmentAvailibility.message,
            });
            console.log(this.state.AppointmentUpdateErrorMessage);
          }
        })
        .catch((error) => {
          this.setState({
            isButtonDisabled: false,
            innerLoader: false,
            openDialog: false,
          });
        });
    } catch (error) {
      console.log(
        'Something Went wrong to update appointment events details! please try again',
        error
      );
    }
  };

  handleEdit = () => {
    this.setState({ operation: 'Edit' });
  };
  handlePatientChange = (event) => {
    if (event.preventDefault) event.preventDefault();
    const data =
      this.state &&
      this.state.addPatientValues.find((element) => {
        if ((element && element.value) === event.target.value) {
          return element;
        }
        return data;
      });
    this.setState({
      patient_ID: event.target.value,
      parent_account_ID: data && data.account_id,
    });
  };

  customDayPropGetter = (date) => {
    if (date.getDate() === 7 || date.getDate() === 15)
      return {
        className: 'special-day',
        style: {
          border: 'solid 3px ' + (date.getDate() === 7 ? '#faa' : '#afa'),
        },
      };
    else return {};
  };

  customSlotPropGetter = (date) => {
    if (date.getDate() === 7 || date.getDate() === 15)
      return {
        className: 'special-day',
      };
    else return {};
  };

  render() {
    const { classes, t } = this.props;
    const {
      events,
      appointmentTypeMaster,
      locationObj,
      picture1_URL,
      picture2_URL,
      picture3_URL,
      locale,
    } = this.state;
    const readOnly = this.state && this.state.operation === 'View';
    const Event = ({ event }) => {
      return (
        <span>
          <strong>{event.title}</strong>
          {event.desc && ':  ' + event.desc}
        </span>
      );
    };
    const EventAgenda = ({ event }) => {
      return (
        <span>
          <em style={{ color: 'black' }}>{event.title}</em>
          <p>{event.desc}</p>
        </span>
      );
    };
    const DateCell = ({ range, value, children }) => {
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      return (
        <div
          className={
            value < now ? 'rbc-day-bg rbc-off-range-bg-disabled' : 'rbc-day-bg'
          }
        >
          {children}
        </div>
      );
    };
    return (
      <div>
        {this.state.loader ? (
          <div className={classes.spinner}>
            <img className={classes.spinnerImage} src={spinner} alt='loading' />
          </div>
        ) : null}
        <Calendar
          selectable
          popup
          defaultDate={moment().toDate()}
          defaultView='month'
          localizer={localizer}
          events={events}
          startAccessor='start'
          endAccessor='end'
          resizable
          style={{ height: 700 }}
          dayLayoutAlgorithm={'no-overlap'}
          components={{
            event: Event,
            agenda: {
              event: EventAgenda,
            },
            dateCellWrapper: DateCell,
          }}
          onSelectEvent={this.onSelectEvent}
          onSelectSlot={this.onSelectSlot}
          onSelecting={this.onSelecting}
          onShowMore={this.onShowMore}
        />
        {/* <FullCalendar
                        plugins={[ dayGridPlugin ]}
                        initialView="dayGridMonth"
                        weekends={false}
                        events={[
                            { title: 'event 1', date: '2019-04-01' },
                            { title: 'event 2', date: '2019-04-02' }
                        ]}
                    /> */}

        {/* Start Delete Dialog */}
        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          open={this.state.isOpenDeleteDialog}
          onClose={this.handleCloseDeleteDialog}
          maxWidth='md'
          aria-labelledby='form-dialog-title'
        >
          {this.state.deleteinnerLoader ? (
            <div className={classes.spinner}>
              <img
                className={classes.spinnerImage}
                src={spinner}
                alt='loading'
              />
            </div>
          ) : null}
          <DialogTitle id='form-dialog-title'>
            {t('Appointment.Popup.AreYouSureToDelete')}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {t('Appointment.Popup.AreYouSureToDeleteAppointment')}:
              <ul>
                <li>
                  {this.state &&
                    this.state.appointment &&
                    this.state.appointment.title}
                </li>
              </ul>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color='primary'
              onClick={this.handleCloseDeleteDialog}
              className={classes.primaryButton}
            >
              {t('Appointment.Popup.Cancel')}
            </Button>
            <Button
              color='primary'
              autoFocus
              onClick={this.handleConfirmDelete}
              className={classes.primaryButton}
            >
              {t('Appointment.Popup.Delete')}
            </Button>
          </DialogActions>
        </Dialog>
        {/* End Delete Dialog */}
        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          open={this.state.openDialog}
          onClose={this.handleCloseDialog}
          maxWidth='md'
          aria-labelledby='form-dialog-title'
        >
          {this.state.innerLoader ? (
            <div className={classes.spinner}>
              <img
                className={classes.spinnerImage}
                src={spinner}
                alt='loading'
              />
            </div>
          ) : null}
          <DialogTitle
            id='form-dialog-title'
            style={{ margin: '0px', marginBottom: '-10px' }}
          >
            {this.state.operation} {t('Appointment.Popup.Appointment')}
            {this.state &&
            (this.state.operation === 'View' ||
              this.state.operation === 'Edit') ? (
              <div className={classes.buttonAllignment}>
                <Tooltip
                  key='single-edit'
                  title={t('Appointment.Popup.EditAppointmentTooltip')}
                >
                  <IconButton
                    aria-label='edit'
                    className={classes.editAppointment}
                    onClick={this.handleEdit}
                  >
                    <Icon style={{ fontSize: 30 }}>edit</Icon>
                  </IconButton>
                </Tooltip>
                <Tooltip
                  key='single-delete'
                  title={t('Appointment.Popup.DeleteAppointmentTooltip')}
                >
                  <IconButton
                    aria-label='delete'
                    className={classes.deleteAppointment}
                    onClick={this.confirmDelete}
                  >
                    <Icon style={{ fontSize: 30 }}>delete</Icon>
                  </IconButton>
                </Tooltip>
              </div>
            ) : (
              ''
            )}
          </DialogTitle>
          <ValidatorForm
            ref='form'
            onSubmit={
              this.state.operation === 'Add'
                ? this.handleSubmit
                : this.handleUpdate
            }
          >
            <DialogContent style={{ paddingTop: '0px' }}>
              <DialogContentText></DialogContentText>
              <Grid container>
                <Grid item xs={12}>
                  <FormControl className={classes.formControl}>
                    <TextValidator
                      autoFocus={false}
                      margin='dense'
                      id='title'
                      name='title'
                      label={t('Appointment.Popup.Title')}
                      type='text'
                      fullWidth
                      onChange={this.handleChange}
                      value={this.state.title}
                      inputProps={{
                        readOnly: Boolean(readOnly),
                      }}
                      validators={['required', 'matchRegexp:^[a-zA-Z0-9 ]*$']}
                      errorMessages={[
                        t('Validation.EnterTitle'),
                        t('Validation.UseAlphabets'),
                      ]}
                      variant='standard'
                    />
                  </FormControl>
                </Grid>
              </Grid>
              <Grid
                container
                className={classes.gridSelect}
                style={{ marginTop: '0%' }}
              >
                <Grid
                  item
                  style={{
                    width: '400px',
                    marginRight: '12px',
                    marginTop: '2px',
                  }}
                >
                  <FormControl className={classes.formControl}>
                    <SelectValidator
                      fullWidth
                      autoFocus={false}
                      id='demo-controlled-open-select'
                      name='appointmentType'
                      label={t('Appointment.Popup.AppointmentType')}
                      open={
                        this.state && this.state.isOpenAppointmentTypeSelect
                      }
                      onClose={this.handleCloseAppointmentSelect}
                      onOpen={this.hanldeOpenAppointmentSelect}
                      onChange={this.handleChange}
                      value={
                        this.state && (this.state.appointmentType_ID || '')
                      }
                      inputProps={{
                        readOnly: Boolean(readOnly),
                      }}
                      validators={['required']}
                      errorMessages={t('Appointment.Type.Error')}
                      variant='standard'
                    >
                      {appointmentTypeMaster &&
                        appointmentTypeMaster.length > 0 &&
                        appointmentTypeMaster.map((res, index) => (
                          <MenuItem
                            key={index}
                            value={res.id}
                            selected
                            sx={{ height: '46px' }}
                          >
                            {res.type}
                          </MenuItem>
                        ))}
                    </SelectValidator>
                  </FormControl>
                </Grid>
                <Grid
                  item
                  style={{
                    width: '400px',
                    marginRight: '12px',
                    marginTop: '3px',
                  }}
                >
                  <FormControl className={classes.formControl}>
                    <TextField
                      id='standard-read-only-input'
                      label={t('Appointment.Popup.Duration')}
                      defaultValue={this.state && this.state.duration}
                      value={this.state.duration || ''}
                      InputProps={{
                        readOnly: true,
                      }}
                      variant='standard'
                    />
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container style={{ marginTop: '-1%' }}>
                <Grid item style={{ marginTop: '16px' }} xs={6}>
                  <FormControl
                    className={classes.formControl}
                    style={{ paddingRight: '12px' }}
                  >
                    <LocalizationProvider
                      dateAdapter={DateAdapter}
                      locale={locale}
                    >
                      <DesktopDatePicker
                        label={t('Appointment.Popup.Date')}
                        value={this.state && this.state.start_date}
                        pattern={(value) =>
                          value
                            ? [
                                /\d/,
                                /\d/,
                                '/',
                                /\d/,
                                /\d/,
                                '/',
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                              ]
                            : []
                        }
                        onChange={this.handleDateChange}
                        disabled={Boolean(readOnly)}
                        renderInput={(params) => (
                          <TextField
                            label='To date'
                            variant='standard'
                            allowKeyboardControl={true}
                            disabled={Boolean(readOnly)}
                            fullWidth
                            {...params}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>
                <Grid item xs={6} sx={{ mt: '16px' }}>
                  <FormControl
                    className={classes.formControl}
                    style={{ paddingRight: '9px' }}
                  >
                    <LocalizationProvider
                      dateAdapter={DateAdapter}
                      locale={locale}
                    >
                      <DesktopTimePicker
                        label={t('Appointment.Popup.Time')}
                        value={this.state && this.state.start_date}
                        onChange={this.handleTimeChange}
                        disabled={Boolean(readOnly)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant='standard'
                            disabled={Boolean(readOnly)}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container style={{ marginTop: '1%' }}>
                <Grid
                  item
                  style={{
                    width: '400px',
                    marginRight: '12px',
                    marginTop: '4px',
                  }}
                >
                  <FormControl className={classes.formControl}>
                    <Selector
                      id='patient_id'
                      label={t('Appointment.Popup.AddPatient')}
                      values={this.state.addPatientValues}
                      selected={this.state.patient_ID}
                      onBlur={this.handlePatientChange}
                      readOnly={readOnly}
                    />
                  </FormControl>
                </Grid>
                <Grid
                  item
                  style={{
                    width: '400px',
                    marginRight: '12px',
                    marginTop: '4px',
                  }}
                >
                  <FormControl className={classes.formControl}>
                    <SelectValidator
                      fullWidth
                      autoFocus={false}
                      id='demo-controlled-open-select-1'
                      name='location'
                      label={t('Appointment.Popup.Location')}
                      open={this.state && this.state.isOpenLocationSelect}
                      onClose={this.handleCloseLocationSelect}
                      onOpen={this.handleOpenLocationSelect}
                      onChange={this.handleChange}
                      value={this.state && (this.state.location_ID || '')}
                      inputProps={{
                        readOnly: Boolean(readOnly),
                      }}
                      validators={['required']}
                      errorMessages={t('Appointment.Location.Error')}
                      variant='standard'
                    >
                      {locationObj &&
                        locationObj.length > 0 &&
                        locationObj.map((res, index) => (
                          <MenuItem
                            key={index}
                            value={res.id}
                            selected
                            sx={{ height: '46px' }}
                          >
                            {res.name}
                          </MenuItem>
                        ))}
                    </SelectValidator>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={12}>
                  <FormControl className={classes.formControl}>
                    <TextValidator
                      autoFocus={false}
                      margin='dense'
                      id='comment'
                      name='comment'
                      label={t('Appointment.Popup.PatientComments')}
                      type='text'
                      fullWidth
                      onChange={this.handleChange}
                      value={this.state.patient_comments}
                      inputProps={{
                        readOnly: Boolean(readOnly),
                      }}
                      variant='standard'
                    />
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container style={{ marginTop: '10px' }}>
                <Grid item md={12}>
                  <InputLabel id='description' className={classes.formControl}>
                    {t('Appointment.Popup.Description')}
                  </InputLabel>
                  <FormControl className={classes.formControl}>
                    <TextValidator
                      autoFocus={false}
                      margin='dense'
                      id='description'
                      labelId='description'
                      name='description'
                      type='text'
                      fullWidth
                      onChange={this.handleChange}
                      value={this.state && this.state.description}
                      multiline
                      rows={7}
                      variant='outlined'
                      inputProps={{
                        readOnly: Boolean(readOnly),
                      }}
                      validators={['required']}
                      errorMessages={[t('Validation.EnterDescription')]}
                    />
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container style={{ marginTop: '-1%' }}>
                <Grid item style={{ marginTop: '16px' }}>
                  <EventIcon />
                </Grid>
                <Grid item style={{ marginTop: '17px', marginLeft: '1%' }}>
                  <Typography>
                    {' '}
                    {this.state && this.state.LoggedInUserName}
                  </Typography>
                </Grid>
              </Grid>
              {readOnly &&
              (picture1_URL === null || picture1_URL === 'null') ? (
                <React.Fragment>
                  <div className={classes.flexItems + ' box-container'}>
                    {picture1_URL === null || picture1_URL === 'null' ? null : (
                      <div className='box'>
                        <div className={classes.picturedropbox}>
                          {readOnly ? (
                            <div>
                              {!picture1_URL && (
                                <AddUserImage className={classes.dropImage} />
                              )}
                              {picture1_URL && (
                                <img
                                  alt=''
                                  src={picture1_URL}
                                  className={classes.dropPic}
                                />
                              )}
                            </div>
                          ) : (
                            <Dropzone
                              id='picture1_DropZone'
                              accept='.png,.jpeg,.jpg'
                              onDrop={this.handleDropPicture1_URL.bind(this)}
                              className={classes.innerBox}
                            >
                              {!picture1_URL && (
                                <AddUserImage className={classes.dropImage} />
                              )}
                              {picture1_URL && (
                                <img
                                  alt=''
                                  src={picture1_URL}
                                  className={classes.dropPic}
                                />
                              )}
                            </Dropzone>
                          )}
                        </div>
                        <div
                          variant='caption'
                          style={{ marginTop: '25px', textAlign: 'center' }}
                        >
                          <p className={classes.captionpictureText}>
                            Picture 1
                          </p>
                          {!readOnly ? (
                            <Button
                              className={classes.btnremove}
                              onClick={this.removePicture1_URL}
                            >
                              Remove Picture 1
                            </Button>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    )}

                    {picture2_URL === null || picture2_URL === 'null' ? null : (
                      <div className='box'>
                        <div className={classes.picturedropbox}>
                          {readOnly &&
                          (picture2_URL === null || picture2_URL === 'null') ? (
                            <div>
                              {!picture2_URL && (
                                <AddUserImage className={classes.dropImage} />
                              )}
                              {picture2_URL && (
                                <img
                                  alt=''
                                  src={picture2_URL}
                                  className={classes.dropPic}
                                />
                              )}
                            </div>
                          ) : (
                            <Dropzone
                              accept='.png,.jpeg,.jpg'
                              id='picture2_DropZone'
                              onDrop={this.handleDropPicture2_URL.bind(this)}
                              className={classes.innerBox}
                            >
                              {!picture2_URL && (
                                <AddUserImage className={classes.dropImage} />
                              )}
                              {picture2_URL && (
                                <img
                                  alt=''
                                  src={picture2_URL}
                                  className={classes.dropPic}
                                />
                              )}
                            </Dropzone>
                          )}
                        </div>
                        <div
                          variant='caption'
                          style={{ marginTop: '25px', textAlign: 'center' }}
                        >
                          <p className={classes.captionpictureText}>
                            Picture 2
                          </p>
                          {!readOnly ? (
                            <Button
                              className={classes.btnremove}
                              onClick={this.removePicture2_URL}
                            >
                              Remove Picture 2
                            </Button>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    )}

                    {picture3_URL === null || picture3_URL === 'null' ? null : (
                      <div className='box'>
                        <div className={classes.picturedropbox}>
                          {readOnly &&
                          (picture3_URL === null || picture3_URL === 'null') ? (
                            <div>
                              {!this.state.picture3_URL && (
                                <AddUserImage className={classes.dropImage} />
                              )}
                              {this.state.picture3_URL && (
                                <img
                                  alt=''
                                  src={this.state.picture3_URL}
                                  className={classes.dropPic}
                                />
                              )}
                            </div>
                          ) : (
                            <Dropzone
                              id='picture3_DropZone'
                              accept='.png,.jpeg,.jpg'
                              onDrop={this.handleDropPicture3_URL.bind(this)}
                              className={classes.innerBox}
                            >
                              {!this.state.picture3_URL && (
                                <AddUserImage className={classes.dropImage} />
                              )}
                              {this.state.picture3_URL && (
                                <img
                                  alt=''
                                  src={this.state.picture3_URL}
                                  className={classes.dropPic}
                                />
                              )}
                            </Dropzone>
                          )}
                        </div>
                        <div
                          variant='caption'
                          style={{ marginTop: '25px', textAlign: 'center' }}
                        >
                          <p className={classes.captionpictureText}>
                            Picture 3
                          </p>
                          {!readOnly ? (
                            <Button
                              className={classes.btnremove}
                              onClick={this.removePicture3_URL}
                            >
                              Remove Picture 3
                            </Button>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </React.Fragment>
              ) : (
                ''
              )}
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.handleCloseDialog}
                color='primary'
                className={classes.primaryButton}
              >
                {this.state && this.state.operation === 'View'
                  ? t('Appointment.Popup.Close')
                  : t('Appointment.Popup.Cancel')}
              </Button>
              {this.state &&
              (this.state.operation === 'Add' ||
                this.state.operation === 'Edit') ? (
                <Button
                  type='submit'
                  color='primary'
                  disabled={this.state.isButtonDisabled}
                  className={classes.primaryButton}
                >
                  {this.state.operation === 'Add'
                    ? t('Appointment.Popup.SaveAppointment')
                    : t('Appointment.Popup.UpdateAppointment')}
                </Button>
              ) : (
                ''
              )}
            </DialogActions>
          </ValidatorForm>
        </Dialog>
      </div>
    );
  }
}

EnhancedTable.propTypes = propTypes;
export default withStyles(useStyles, { withTheme: true })(
  withTranslation()(EnhancedTable)
);



// WEBPACK FOOTER //
// ./src/components/appointment/index.js